export default "__VITE_ASSET__DrEQH2ni__"